import Vue from "vue";
import Vuex from "vuex";
import { getUserInfo } from "@/views/Mobile/api/index.js";


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isMobile: false,
    isLogin: false,
  },
  getters: {
    isMobile: (state) => state.isMobile, // 是否是移动端
  },
  mutations: {
    setIsMobile(state, payload) {
      state.isMobile = !!payload?.isMobile;
    },
    setIsLogin(state, payload) {
      state.isLogin = !!payload?.isLogin;
    },
  },
  actions: {
    // 获取登录状态
    async getLoginStatus({ commit }) {
      const loginInfo = await getUserInfo();
      const loginCode = loginInfo?.code; // 用户状态码
      commit("setIsLogin", { isLogin: loginCode === 2 });
    },
  },
  modules: {},
});
